
import React, { createContext, useState, useEffect } from 'react';
// import api from "../../../services/api";

const Context = createContext();
function EditProvider({ children }) {

  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isCreate, setIsCreate] = useState(false)
  const [isEdit, setIsEdit] = useState(false)

  const [representanteEdit, setRepresentanteEdit] = useState(undefined)

  function toggleEdit() {
    setIsCreate(false)
    setIsEdit(true);
    setIsOpenModal(true)
  }
  function toggleCreate() {
    setIsEdit(false)
    setIsCreate(true);
    setIsOpenModal(true)
  }

  const handleClose = () => {
    setIsCreate(false)
    setIsEdit(false)
    setIsOpenModal(false);
  };

  useEffect(() => {
  }, [isOpenModal])

  return (
    <Context.Provider value={{
      isOpenModal,
      setIsOpenModal,
      isEdit,
      isCreate,
      toggleEdit,
      toggleCreate,
      handleClose,
      representanteEdit,
      setRepresentanteEdit
    }}>
      {children}
    </Context.Provider>
  );
}


export { Context, EditProvider };